export default __webpack_public_path__ + "static/media/stefano.408c8b3e.png";